import React from 'react'
import classNames from 'classnames'
import { Modal } from 'components'
import {
  IntroScreen,
  FormScreen,
  ReviewScreen,
  SuccessScreen,
} from './componentes'
import styles from './ProposalWizard.module.scss'

const ProposalWizard = ({
  opened = false,
  closeModal,
  screen = 'intro',
  property = {},
  faqOpenIndex = null,
  onToggleFaq,
  onGoToForm,
  onCloseIntro,
  form = {},
  touched = {},
  errors = {},
  onChange,
  onBlur,
  onAddAttachment,
  onRemoveAttachment,
  onTryReview,
  onGoToIntro,
  onGoToEdit,
  onSubmit,
  onFinish,
  isSubmitting = false,
  termsAccepted = false,
  onToggleTerms,
  marketingAccepted = false,
  onToggleMarketing,
  loadingSalesChannel = false,
}) => (
  <Modal
    opened={opened}
    closeModal={closeModal}
    className={classNames(styles.wrappedModal, {
      [styles.introModal]: screen === 'intro',
      [styles.successModal]: screen === 'success',
    })}
    noOverflowX
    closeButtonPosition="right"
    disableBackdropClose
  >
    <section className={styles.proposalWizard}>
      {screen === 'intro' && (
        <IntroScreen
          faqOpenIndex={faqOpenIndex}
          onToggleFaq={onToggleFaq}
          onCloseIntro={onCloseIntro}
          onGoToForm={onGoToForm}
        />
      )}

      {screen === 'form' && (
        <FormScreen
          form={form}
          touched={touched}
          errors={errors}
          onChange={onChange}
          onBlur={onBlur}
          onAddAttachment={onAddAttachment}
          onRemoveAttachment={onRemoveAttachment}
          onTryReview={onTryReview}
          onGoToIntro={onGoToIntro}
          loadingSalesChannel={loadingSalesChannel}
        />
      )}

      {screen === 'review' && (
        <ReviewScreen
          form={form}
          property={property}
          onGoToEdit={onGoToEdit}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          termsAccepted={termsAccepted}
          onToggleTerms={onToggleTerms}
          marketingAccepted={marketingAccepted}
          onToggleMarketing={onToggleMarketing}
        />
      )}

      {screen === 'success' && <SuccessScreen onFinish={onFinish} />}
    </section>
  </Modal>
)

export default React.memo(ProposalWizard)
